import {parseSupportingContentItem} from "./SupportingContentParser";

import styles from "./SupportingContent.module.css";
import {SiSap} from "react-icons/si";
import {LiaSalesforce} from "react-icons/lia";

interface Props {
    supportingContent: string[] | { text: string[]; images?: { url: string }[]; results: SupportingContentResult[] };
}

interface SupportingContentResult {
    sourcefile: string;
    content: string;
}

export const SupportingContent = ({supportingContent}: Props) => {
    const textItems: SupportingContentResult[] = !Array.isArray(supportingContent) && 'results' in supportingContent
        ? supportingContent.results
        : [];

    const imageItems = !Array.isArray(supportingContent) ? supportingContent?.images || [] : [];

    return (
        <ul className={styles.supportingContentNavList}>
            {textItems.map((item, ind) => {
                const fileName = item.sourcefile;
                const parsed = parseSupportingContentItem(item.content);

                if (fileName.endsWith(".txt")) {
                    if (fileName.startsWith("SAP")) {
                        const ticketId = fileName.replace(".txt", "").replaceAll("_", " ");

                        return (<>
                                <div className={"w-full h-full border rounded bg-white flex flex-col"}>
                                    <div className={"flex items-center pl-2 space-y-2 h-10 bg-blue-50 text-blue-600"}>
                                        <SiSap className="mx-1 w-4 h-4"/>
                                        {ticketId}
                                    </div>
                                    <div className={"p-2"}>
                                        {parsed.content}
                                    </div>
                                </div>
                            </>
                        )
                            ;
                    } else {
                        const ticketId = fileName.replace(".txt", "");

                        return (
                            <div key={ind} className={"w-full h-full border rounded bg-white flex flex-col cursor-pointer"}
                                 onClick={() => {
                                     window.open(`https://weinig.lightning.force.com/lightning/r/Case/${ticketId}/view`, "_blank");
                                 }}>
                                <div className={"flex items-center pl-2 space-y-2 h-16 bg-blue-50 text-blue-600"}>
                                    <LiaSalesforce className={"mx-1 w-4 h-4"}/>
                                    Ticket
                                </div>
                                {/*<div className={"p-2"}>*/}
                                {/*    {parsed.content}*/}
                                {/*</div>*/}
                            </div>
                        );
                    }
                }

                return (
                    <li className={styles.supportingContentItem} key={ind}>
                        <h4 className={styles.supportingContentItemHeader}>{parsed.title}</h4>
                        {parsed && parsed.content && (
                        <p className={styles.supportingContentItemText}
                            dangerouslySetInnerHTML={{__html: parsed.content}}/>
                        )}
                    </li>
                );
            })}
            {imageItems?.map((img, ind) => {
                return <img className={styles.supportingContentItemImage} src={img.url} key={ind} alt="Supporting Content"/>;
            })}
        </ul>
    );
};
